<div class="row justify-content-left text-center" [style.margin-left]="showAddCard ? '24px' : '0'">

  <div *ngIf="showAddCard" class=" mb-3" style="margin-right: 68px">
    <div class="rounded shadow-sm p-2 custom-card-size d-flex flex-column align-items-center justify-content-center"
      [style.border-style]="isAddCardActive ? 'solid' : 'dashed'"
      [style.border-width]="isAddCardActive ? '1px' : '1px'"
      [style.border-color]="'#134AD3'"
      (click)="openModal('ajouter')"
      style="cursor: pointer; background-color: rgba(115, 103, 240, 0.03);"
    >

        <img *ngIf="stationLogoUrl" [src]="stationLogoUrl" alt="Logo station" style="max-height: 36px; width: auto; margin-bottom: 15px; object-fit: contain;">
        <i *ngIf="!stationLogoUrl" class="bi bi-bank" style="font-size: 28px;margin-bottom: 15px;color: rgba(47, 43, 61, 0.9)"></i>
      <h5 class="mb-1" style="font-weight: 500; font-size: 16px;color: rgba(47, 43, 61, 0.9)">Ajoutez un compte bancaire</h5>
      <button
        class="btn d-flex align-items-center justify-content-center"
        style="width: 38px; height: 38px; padding: 0; background-color: #EEEDF0;"
      >
        <i data-feather="plus" [size]="25"></i>
      </button>
    </div>
  </div>

  <div *ngFor="let account of accounts; let i = index" class=" mb-3" [style.margin-right]="'68px'" [style.margin-left]="!showAddCard && i === 0 ? '0' : ''">
    <div class="border rounded shadow-sm p-1 custom-card-size text-center position-relative"
         [class.border-primary]="selectable && selectedAccountId === account.id"
         [class.border-secondary]="selectable && selectedAccountId !== account.id"
         [style.border-color]="selectable ? (selectedAccountId === account.id ? '#134AD3' : '#6c757d') : '#134AD3'"
         [style.cursor]="selectable ? 'pointer' : 'default'"
         (click)="selectable && onAccountClick(account)">

      <div *ngIf="showStatusSwitch" class="custom-control custom-switch custom-control-success" style="position: absolute; top: 10px; right: 10px;">
        <input type="checkbox" [checked]="account.statut" class="custom-control-input" [id]="'customSwitch' + i"
               (change)="openModal('etat', account, !account.statut)">
        <label class="custom-control-label" [for]="'customSwitch' + i"></label>
      </div>

      <div style="min-height: 28px; margin-bottom: 0.5rem;" class="d-flex align-items-center justify-content-center">
        <img *ngIf="getAccountLogoSrc(account)" [src]="getAccountLogoSrc(account)" alt="Logo" style="max-width: 120px; max-height: 36px; width: auto; height: auto; object-fit: contain;">
        <i *ngIf="!getAccountLogoSrc(account)" class="bi bi-bank" style="font-size: 24px; color: rgba(47, 43, 61, 0.65)"></i>
      </div>
      <p class="mb-0 size15">{{ account.nom }}</p>
      <p class="mb-0 size13">{{ account.rib }}</p>
      <p class="mb-1 text-muted size10" *ngIf="showDate" >Dernière opération : {{ formatDate(account.date_update || '') }}</p>
      <p class="mb-1 size13" *ngIf="showSolde" >Solde : <span style="color:#134AD3">{{ getSolde(account.id) }} TND</span></p>
      <div *ngIf="!selectable">
        <button *ngIf="!showExtraEdit" class="btn btn-primary waves-light mx-auto"  (click)="openModal('update', account)">Modifier</button>
        <div *ngIf="showExtraEdit" class="d-flex p-0" style="gap: 13px">
          <button class="btn btn-primary waves-light ml-4"  (click)="openModal('update', account)">Modifier</button>
          <button  class=" bouttonStyle" (click)="detailbanque(account)"> <i data-feather="eye" [size]="13" class="cursor-pointer"></i></button>
        </div>
      </div>
      <div *ngIf="selectable && selectedAccountId === account.id" class="mt-2">
        <span style="color: #134AD3; font-weight: 600; font-size: 14px;">✓ Sélectionné</span>
      </div>
    </div>
  </div>


  <app-croud-compte-bancaire *ngIf="showModal" #croud></app-croud-compte-bancaire>
</div>
